module.exports = __webpack_public_path__ + "static/media/meal-plan-enrollment.e6095063.png";